import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const valricoConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Valrico Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Valrico, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_valrico',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Valrico',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Valrico Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide expert tree care to the 
     residential neighborhoods and larger properties of <strong>Valrico</strong>. 
     This East Hillsborough community has a mix of established subdivisions and 
     spacious lots where trees grow large and unchecked creating real hazards 
     when storm season arrives. Overhanging limbs, leaning trees after heavy 
     rain, and storm damaged canopies all need professional handling before 
     they cause expensive damage.`,

    `We specialize in <strong>hazardous tree removal and canopy management</strong> 
     large oak and pine removals, storm cleanup and debris hauling, precision 
     trimming near homes and outbuildings, and canopy reductions that significantly 
     reduce your property's wind load risk. We handle every job from start to 
     cleanup.`,

    `<strong>Sam's Tree Service</strong> delivers trusted, affordable tree care 
     throughout <strong>Valrico</strong> and the surrounding 
     <strong>East Hillsborough</strong> area keeping your property safe 
     and your landscape healthy all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Valrico, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Valrico = () => <LocationPage config={valricoConfig} />;
export default Services_Valrico;
